module.exports = __webpack_public_path__ + "img/scroll.9a4e6c1e.webp";